import React from 'react'
import {
  countryCurrencyEnum,
  isItemAtMaxQty,
  isOneTimeItem,
} from '../kp-11-link/kp-11Link-utility/kp11-utility'
import {CardPlanBodyStyle} from '../kp-11-link/kp-11Link-catalog/kp-11Link-catalog-cards/kp-11Link-catalog-cards-style'
import {fetchPlanIcon} from '../../../utils/fetch-plan-icon'
import {STAND_ALONE_CARD} from '../../../utils/constants'
import {Button} from '@thryvlabs/maverick'
import {useSelector} from 'react-redux'
import {selectKP11SelectCartCentersNApps} from '../../../app-store/kp11CartSlice'
import {formatPrice} from '../../../utils/currency-format'

export const RegularCardComponent = ({
  cardDetails,
  cardName,
  cardHeaderText = '',
  handleCardAction,
  isDisabled,
  isChecked,
  customFields,
  groupKey,
  country = 'US',
  hideRadio = false,
}) => {
  const targetCurrency = countryCurrencyEnum[country] || cardDetails?.currency
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const isMaxQtyReached = isItemAtMaxQty({
    cartCentersAndApps,
    item: cardDetails,
  })
  // create card with name, radio button and optional text
  // const dispatch = useDispatch()
  const createCard = card => {
    let iconDetail = {}
    if (!card.name.toLowerCase().includes('center')) {
      iconDetail = fetchPlanIcon(card.name)
    }
    const getAmountWithCurrencySymbol = (
      prices,
      customFields,
      currency = 'USD',
    ) => {
      const price = prices?.find(p => p.currency === currency)

      if (!price) return null
      return formatPrice(price.unitAmount, 1, '', country)
    }
    const billingType = 'Billed Monthly'
    // check for standalone card
    const isStandAloneCard = STAND_ALONE_CARD.includes(card.code)

    return (
      <div
        className={`card-plan-item d-flex  ${isDisabled ? 'disabled' : ''} 
      ${isDisabled || isMaxQtyReached ? 'checked' : ''}`}
        style={{maxWidth: '100%'}}
        onClick={() => {
          if (isStandAloneCard) {
            handleCardAction()
          }
        }}
      >
        {isStandAloneCard && !hideRadio && (
          <div className="radio-btn">
            <input
              type="radio"
              checked={isChecked}
              disabled={isDisabled}
              readOnly
            />
          </div>
        )}
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex justify-content-between w-100">
            <div className="item-content-wrap">
              <div
                className="d-flex align-items-center"
                style={{marginTop: iconDetail?.icon ? '-15px' : '0px'}}
              >
                {iconDetail?.icon && (
                  <div className="card-icon">
                    <img
                      src={iconDetail?.icon}
                      alt="plan logo"
                      className="options-logo rounded"
                      style={{height: '50px', width: '50px'}}
                    />
                  </div>
                )}
                <div className="plan-item-radio-label">{card?.name}</div>
              </div>

              <div className="plan-item-price">
                {getAmountWithCurrencySymbol(
                  card?.currencies,
                  customFields,
                  targetCurrency,
                )}
              </div>
              {!isOneTimeItem(card?.code) && (
                <div className="plan-item-subtext">
                  {card?.billingType || billingType}
                </div>
              )}
            </div>
            <div>
              {!isStandAloneCard && (
                <Button
                  variant="primary"
                  disabled={isDisabled || isMaxQtyReached}
                  onClick={() => {
                    if (isDisabled || isMaxQtyReached) return
                    handleCardAction()
                  }}
                >
                  Add to Cart
                </Button>
              )}
            </div>
          </div>
          {/* <div className="item-content-wrap">
            <div
              className="d-flex align-items-center"
              style={{marginTop: iconDetail?.icon ? '-15px' : '0px'}}
            >
              {iconDetail?.icon && (
                <div className="card-icon">
                  <img
                    src={iconDetail?.icon}
                    alt="plan logo"
                    className="options-logo rounded"
                    style={{height: '50px', width: '50px'}}
                  />
                </div>
              )}
              <div className="plan-item-radio-label">{card?.name}</div>
            </div>
            <div className="plan-item-price">
              {getAmountWithCurrencySymbol(card?.currencies, customFields)}
            </div>
            <div className="plan-item-subtext">
              {card?.billingType || billingType}
            </div>
          </div> */}
        </div>
      </div>
    )
  }

  return (
    <CardPlanBodyStyle>
      {cardHeaderText.length > 0 && (
        <div className="card-plan-subText">{cardHeaderText}</div>
      )}

      {createCard(cardDetails)}
    </CardPlanBodyStyle>
  )
}
